export default {
  messages: {
    required: 'required field',
    requireTrue: 'required field',
    phoneNumber: 'invalid telephone',
    alpha: 'only contain alphabetic characters',
    email: 'The email value is not valid',
    min: (fieldName, params) => `minimum number of characters ${params[0]}`,
    decimal: 'The field accepts only decimals value',
    confirmed: 'The password confirmation does not match.',
    numeric: 'just numeric value',
    length: 'incorrect length',
    max: 'Only 400 characters allowed',
    min_value: (fieldName, params) => `The field must be ${params} or more`,
    max_value: (fieldName, params) => `The field must be ${params} or less`,
    uniqueEmail: 'email exist, loggin or change email',
    passwordM: fieldName => `The ${fieldName} need at least 1 number, 1 uppercase and 1 lowercase character`,
    dob18: fieldName => `18 years old`
  }
}
